import { AES, enc } from "crypto-js";

const secretKey = process.env.REACT_APP_CRYPT_KEY || '';

export function storeEncryptedItem(key: string, value: string): void {
    let encryptedItem: string = AES.encrypt(value, secretKey).toString()
    sessionStorage.setItem(key, encryptedItem);
}

export function getDecryptedItem(key: string): string {
    let encryptedItem = sessionStorage.getItem(key) || '';
    let decryptedBytes = AES.decrypt(encryptedItem, secretKey);
    let decryptedItem = decryptedBytes.toString(enc.Utf8);

    return decryptedItem;
}